import React from "react";
import imgBg from "img/bg_1.png";
import imgHeading from "img/title.png";

const Header = () => {
  return (
    <React.Fragment>
      <h1 className="main__title  visually-hidden">письмо Деду Морозу</h1>
      <div class="main-bg">
        <img src={imgBg} alt="#" />
      </div>

      <div className={"main__heading"}>
        <img src={imgHeading} alt="#" />
      </div>
    </React.Fragment>
  );
};

export default Header;
